<template>
  <v-card-text @click.stop>
    <v-row
      class="my-0"
      :class="{
        unableProd: !product.active
      }"
    >
      <v-col
        v-if="showMode !== 'simple'"
        class="d-flex justify-content-center"
        :cols="showMode === 'grid' ? 12 : 2"
      >
        <i-image
          class="product-image"
          :style="{
            width: '10em !important',
            height: '8em !important'
          }"
          :value="productImage"
          :preview="true"
          :readonly="true"
        />
      </v-col>

      <v-col
        class="d-flex flex-column justify-content-center pt-0 g-1"
        cols="12"
        :md="showMode != 'grid' ? 3 : 12"
      >
        <p class="primary--text font-weight-bold mb-0">
          {{ product.internalCode }}
        </p>
        <p
          class="primary--text font-weight-black mb-0"
          :class="{
            title: showMode === 'grid',
            'subtitle-1': showMode !== 'grid'
          }"
        >
          {{ product.name }}
        </p>
        <p
          v-if="product.can_be !== 'SALE'"
          class="success--text font-weight-bold mb-0"
        >
          {{ $tc('inventoriable') }}
        </p>
        <p
          v-if="product.can_be !== 'SALE'"
          class="font-weight-bold mb-0"
          :class="{ 'text-danger': product.quantity == 0 }"
        >
          {{ $tc('stock') }}: {{ product.quantity }}
        </p>
      </v-col>

      <v-col
        cols="12"
        :md="showMode == 'simple' ? 7 : showMode == 'list' ? 7 : 12"
      >
        <v-row dense>
          <v-col cols="12" :sm="showMode === 'grid' ? 12 : 6">
            <v-text-field
              color="secondary"
              dense
              min="0"
              outlined
              type="number"
              hide-details
              :label="$tc('amount', 1)"
              v-model.number="quantity"
            />
          </v-col>
          <v-col cols="12" :sm="showMode === 'grid' ? 12 : 6">
            <i-money
              hide-details
              :name="`price-${product.pk}`"
              :label="$tc('price', 1)"
              v-model="price"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col
        class="d-flex flex-column justify-content-center"
        cols="12"
        :md="showMode != 'grid' ? 2 : 12"
      >
        <v-btn
          color="secondary"
          dark
          block
          :disabled="!canAdd"
          :loading="adding"
          @click.stop="addProduct"
        >
          {{ $t('add_product') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
export default {
  name: 'ProductSelectionCard',
  props: {
    product: {
      type: Object,
      required: true
    },
    showMode: {
      type: String,
      default: 'grid'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      quantity: 1,
      price: 0,
      adding: false
    }
  },
  computed: {
    productImage() {
      return (
        this.product.image ||
        this.product.thumbnail ||
        require('@/assets/default_image.png')
      )
    },
    canAdd() {
      return Number(this.quantity) > 0 && !this.adding && !this.loading
    }
  },
  created() {
    this.syncProduct()
  },
  watch: {
    'product.pk'() {
      this.syncProduct()
    }
  },
  methods: {
    syncProduct() {
      this.quantity = 1
      this.price = this.product.pricePurchase || 0
      this.adding = false
    },
    addProduct() {
      if (!this.canAdd) {
        return
      }
      this.adding = true
      this.$emit(
        'add',
        {
          product: this.product.pk,
          quantity: Number(this.quantity),
          price: Number(this.price),
          tax: this.product.tax || 0,
          name: this.product.name,
          code: this.product.internalCode,
          thumbnail: this.product.thumbnail || this.product.image || null
        },
        () => {
          this.adding = false
          this.quantity = 1
          this.price = this.product.pricePurchase || 0
        }
      )
    }
  }
}
</script>
